import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../../core/http/api.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { EventService } from '../services/utc.service';
import {
  catchError,
  forkJoin,
  map,
  Observable,
  of,
  switchMap,
  tap,
} from 'rxjs';
@Component({
  selector: 'app-configuration-general',
  templateUrl: './configuration-general.component.html',
  styleUrls: ['./configuration-general.component.css'],
  providers: [MessageService],
})
export class ConfigurationGeneralComponent implements OnInit {
  @Output() messageEvent = new EventEmitter<boolean>();
  showConfirmSaveDialog: boolean = false;
  configId: string = '';
  logo: any = null;
  image: any;
  isButtonDisabled: boolean = true;
  public isPermissionConfiguracionOnly!: boolean;
  showProgressBar: boolean = false;
  countries_code_catalog: any[] = [];
  messaging_services_catalog: any[] = [];
  timezone_catalog: any[] = [];
  language_catalog: any[] = [];
  operatorId: string = '';

  favicon: any = null;
  faviconImage: any = null;

  defaultValues = {
    timezone: null,
    language: null,
    logo: null,
    current_date: new Date(),
    favicon: null,
  };

  showLoadSkeleton: boolean = false;
  incomplete: boolean = false;
  isSaved: boolean = true;
  timeZoneUtcSelected: string = '';
  // public selectedCountry: any =   //{ id:'clabcdo4k000yur7c0eem0noj', country: 'México', ladaCode: '(+52)', flagCode: 'mx' };
  // {
  //   id: "clabcdo4k000yur7c0eem0noj",
  //   country: "México",
  //   ladaCode: "(+52)",
  //   flagCode: "mx",
  //   isActive: true,
  //   createdAt: "2022-11-10T17:26:30.493Z",
  //   updatedAt: "2022-11-10T17:23:12.321Z"
  // }

  // public selectedTimezone: any = {
  //   id: "clawpkldr000suro8yqdjfb6v",
  //   name: "UTC-06:00",
  //   description: "UTC-06:00",
  //   isActive: true,
  //   createdAt: "2022-11-25T16:18:58.238Z",
  //   updatedAt: "2022-11-25T16:15:02.419Z"
  // }

  // selectedLanguage: any = {
  //   id: "clawoq96w0000uro8rexpohqd",
  //   name: "Español",
  //   description: "Español",
  //   isActive: true,
  //   createdAt: "2022-11-25T15:55:22.760Z",
  //   updatedAt: "2022-11-25T15:54:54.287Z"
  // }

  public generalForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private messageService: MessageService,
    private activRoute: ActivatedRoute,
    private auth: AuthService,
    private eventService: EventService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    const incomplete = this.activRoute.snapshot.queryParamMap.get('incomplete');
    if (incomplete) {
      this.incomplete = true;
    }

    this.generalForm = this.formBuilder.group({
      timezone: [null, [Validators.required]],
      language: [null, [Validators.required]],
      current_date: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.setIsPermissionConfiguracionOnly();
    this.getTimezoneCatalog();
    this.getLanguageCatalog();
    //this.getOperatorConfig();
    this.getOperatorConfigByOperatorId();
  }

  setIsPermissionConfiguracionOnly() {
    this.isPermissionConfiguracionOnly =
      this.auth.getPermission('Configuración') &&
      !this.auth.getPermission('Editar Casino General') &&
      !this.auth.getPermission('Editar Gestión de Créditos')
        ? true
        : false;
  }

  getOperatorConfig(operatorId?: string) {
    this.showLoadSkeleton = true;

    //Can filter in future versions
    this.api.list(`operator/operator-config`).subscribe((res) => {
      //default values from ep
      this.defaultValues.timezone = res.data.timeZoneCatId;
      this.defaultValues.language = res.data.languageCatId;
      this.defaultValues.logo = res.data.logoUrl;
      this.timeZoneUtcSelected = res.data.timeZoneCat.description;
      //set Values
      this.configId = res.data.id;
      this.logo = res.data.logoUrl;
      this.favicon = res.data.faviconOperatorUrl;
      this.generalForm.get('timezone')?.setValue(res.data.timeZoneCatId);
      this.generalForm.get('language')?.setValue(res.data.languageCatId);

      const utcOffsetString = this.timeZoneUtcSelected;
      const match = utcOffsetString.match(/UTC([+-]\d+):(\d+)/);
      if (match) {
        const utcOffsetHours = parseInt(match[1], 10);
        const formattedDate =
          this.getFormattedDateWithUtcOffset(utcOffsetHours);
        this.generalForm.get('current_date')?.setValue(formattedDate);
      } else {
        console.log('UTC no valido');
      }

      this.generalForm.get('timezone')?.setValue(res.data.timeZoneCatId);

      setTimeout(() => {
        this.showLoadSkeleton = false;
      }, 750);
    });
  }

  getTimezoneCatalog() {
    this.showLoadSkeleton = true;
    this.api.list('catalogs/timezone-catalog').subscribe((res) => {
      this.timezone_catalog = res.data;
      setTimeout(() => {
        this.showLoadSkeleton = false;
      }, 750);
    });
  }

  getLanguageCatalog() {
    this.showLoadSkeleton = true;
    this.api
      .list('catalogs/language-catalog?isActive=true')
      .subscribe((res) => {
        this.language_catalog = res.data;
        //console.log(res.data);
        setTimeout(() => {
          this.showLoadSkeleton = false;
        }, 750);
      });
  }

  changeSelect() {
    const desiredId = this.generalForm.get('timezone')?.value;
    const selectedTimeZone = this.timezone_catalog.find(
      (timeZone) => timeZone.id === desiredId
    );
    const utcOffsetString = selectedTimeZone.description;
    const match = utcOffsetString.match(/UTC([+-]\d+):(\d+)/);

    if (match) {
      const utcOffsetHours = parseInt(match[1], 10);
      const formattedDate = this.getFormattedDateWithUtcOffset(utcOffsetHours);
      this.generalForm.get('current_date')?.setValue(formattedDate);
    } else {
      console.log('UTC no valido');
    }
    if (
      this.defaultValues.timezone === this.generalForm.get('timezone')?.value &&
      this.defaultValues.language === this.generalForm.get('language')?.value
    ) {
      this.isButtonDisabled = true;
    } else {
      if (this.generalForm.valid) {
        this.isButtonDisabled = false;
      } else {
        this.isButtonDisabled = true;
      }
    }
  }

  saveImage = (data: any): Observable<void> => {
    this.showProgressBar = true;
    return this.api
      .uploadOperatorLogo('operator/upload-logo-img', data)
      .pipe(map(() => {}));
  };

  dataSaved = () => {
    this.messageEvent.emit(this.isSaved);
  };

  save() {
    this.showConfirmSaveDialog = true;
    const data = {
      timeZoneCatId: this.generalForm.get('timezone')?.value,
      languageCatId: this.generalForm.get('language')?.value,
    };

    this.showProgressBar = true;

    this.api
      .updateDirect('operator/operator-config', data)
      .pipe(
        switchMap((response) => {
          if (response.statusCode !== 200) {
            throw new Error('Error al guardar los cambios');
          }

          const uploadTasks: Observable<void>[] = [];

          if (
            this.defaultValues.logo !== this.logo &&
            !this.logo.includes('https')
          ) {
            uploadTasks.push(
              this.saveImage({ file: this.image, id: this.configId })
            );
          }

          if (
            this.defaultValues.favicon !== this.favicon &&
            !this.favicon.includes('https')
          ) {
            uploadTasks.push(
              this.saveFavicon({ file: this.faviconImage, id: this.configId })
            );
          }

          return uploadTasks.length ? forkJoin(uploadTasks) : of(null);
        }),
        tap(() => {
          this.showProgressBar = false;
          this.showConfirmSaveDialog = false;
          setTimeout(() => {
            this.messageService.add({
              severity: 'success',
              summary: 'Cambios aplicados satisfactoriamente',
            });
          }, 300);
          this.getOperatorConfigByOperatorId();
          //this.getOperatorConfig();
          this.dataSaved();
          this.isButtonDisabled = true;
          this.eventService.reloadSellComponent.emit();
        }),
        catchError((err) => {
          console.error(err);
          this.showProgressBar = false;
          setTimeout(() => {
            this.messageService.add({
              severity: 'error',
              summary: 'Ha ocurrido un error al querer guardar los cambios',
            });
          }, 300);
          return of(null);
        })
      )
      .subscribe();
  }

  closeDialog = () => {
    this.showConfirmSaveDialog = false;
    !this.incomplete ? document.body.classList.add('p-overflow-hidden') : '';
  };

  showDialog = () => {
    this.isButtonDisabled
      ? (this.showConfirmSaveDialog = false)
      : (this.showConfirmSaveDialog = true);
  };

  loadLogo() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.png, .jpeg, .jpg';
    input.onchange = (e: any) => {
      const file = e.target.files[0];
      this.image = file;
      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        this.messageService.add({
          key: 'bc',
          severity: 'error',
          summary: 'Formato de archivo no permitido',
        });
        return;
      }
      if (file.size > 1000000) {
        this.defaultValues.logo === null
          ? 'assets/images/no-photo-available.png'
          : this.defaultValues.logo;
        this.messageService.add({
          key: 'bc',
          severity: 'error',
          summary: 'La imagen excede el límite de peso',
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.logo = reader.result;
        this.messageService.add({
          severity: 'success',
          summary: 'Imagen cargada, no olvides guardar tus cambios',
        });
        this.isButtonDisabled = false;
      };
    };
    input.click();
  }

  getOperatorConfigByOperatorId = () => {
    this.api.getOperatorId(this.auth.getToken()).subscribe({
      next: (res) => {
        this.operatorId = res.data.operatorId;
        this.getOperatorConfig(res.data.operatorId);
      },
    });
  };

  getFormattedDateWithUtcOffset(utcOffsetHours: number): string {
    const currentDate = new Date();
    const utcTime = currentDate.getTime() + currentDate.getTimezoneOffset();
    const adjustedTime = utcTime + utcOffsetHours * 60 * 60 * 1000;
    const adjustedDate = new Date(adjustedTime);
    const year = adjustedDate.getUTCFullYear();
    const month = (adjustedDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = adjustedDate.getUTCDate().toString().padStart(2, '0');
    const hours = adjustedDate.getUTCHours().toString().padStart(2, '0');
    const minutes = adjustedDate.getUTCMinutes().toString().padStart(2, '0');
    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;

    return formattedDate;
  }

  loadFavicon = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.png, .jpeg, .jpg, .ico, .svg';
    input.onchange = (e: any) => {
      const file = e.target.files[0];
      console.log(file.type);
      if (
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/x-icon' &&
        file.type !== 'image/vnd.microsoft.icon' &&
        file.type !== 'image/svg+xml'
      ) {
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'Formato de archivo no permitido',
        });
        return;
      }
      if (file.size > 1048576) {
        this.defaultValues.logo === null
          ? 'assets/images/no-photo-available.png'
          : this.defaultValues.logo;
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'La imagen excede el límite de peso',
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = 48;
          canvas.height = 48;
          ctx?.drawImage(img, 0, 0, 48, 48);
          canvas.toBlob((blob) => {
            if (blob) {
              this.faviconImage = new File([blob], file.name, {
                type: file.type,
              });
              this.favicon = canvas.toDataURL(file.type);
              this.messageService.add({
                severity: 'success',
                summary: 'Imagen cargada, no olvides guardar tus cambios',
              });
              this.isButtonDisabled = false;
              this.changeDetectorRef.detectChanges();
            }
          }, file.type);
        };
      };
    };
    input.click();
  };

  saveFavicon = (data: any): Observable<void> => {
    this.showProgressBar = true;
    return this.api
      .uploadOperatorLogo('operator/upload-favicon-img', data)
      .pipe(map(() => {}));
  };
}
